import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import { lessonIconDefinition } from "./lessonIcons";

export interface PresentationIconProps {
  readonly title: string;
  readonly iconName?: string | null;
  readonly bgColor?: string | null;
  readonly fgColor?: string | null;
  readonly size?: number;
  readonly className?: string;
}

const DEFAULT_BG = "#1b4d2e";
const DEFAULT_FG = "#fdf9f3";

export function PresentationIcon({
  title,
  iconName,
  bgColor,
  fgColor,
  size = 2.75,
  className,
}: PresentationIconProps) {
  const background = bgColor?.trim() || DEFAULT_BG;
  const foreground = fgColor?.trim() || DEFAULT_FG;
  const icon = lessonIconDefinition(iconName) ?? faBookOpen;

  return (
    <span
      className={["lesson-icon-tile", "quiz-icon-tile", className ?? ""].filter(Boolean).join(" ")}
      style={{
        width: `${size}rem`,
        height: `${size}rem`,
        background,
        color: foreground,
        fontSize: `${size * 0.45}rem`,
      }}
      title="Presentation"
      aria-label="Presentation"
    >
      <FontAwesomeIcon icon={icon} />
      <span className="visually-hidden">{title}</span>
    </span>
  );
}
